import type { StyleSystemProps } from '@withjoy/joykit';

const containerStyles: StyleSystemProps = {
  alignItems: 'flex-start',
  gap: 3,
  backgroundColor: 'mono2',
  border: '1px solid',
  borderColor: 'mono3',
  borderRadius: 8,
  padding: 4,
  marginTop: 5,
};

const textColumnStyles: StyleSystemProps = {
  flexDirection: 'column',
  gap: 1,
};

export const styles = {
  container: containerStyles,
  textColumn: textColumnStyles,
};
